import React, { useState, useEffect } from "react";
import { gainwix_icons } from "../../../../../api/ApiConfig";

import { useDispatch } from "react-redux";
import { updateToggleToast } from "../../../../../reduxToolkit/appSlice";
import { useAspSelector } from "../../../../../test/jest-redux-hooks";

import { read, utils } from "xlsx";
import { ICONS } from "../../../../../assets/icons";

import Loader from "../../../../../components/commonComponents/Loader/Index";
import Dropdown from "../../commonComponents/dropdown";

import FileDownload from "../../../../campaign/components/BroadcastSetting/FileDownload";

import { crmBulkUpload, AttributeList, AttributeTypes, AudienceSetList } from "../../../api/Api";

import { crmUploadFile } from "../../../../../helper/crmUploadFile";
import ColumnMapping from "./ColumnMapping";

const UploadFromCsv = ({
  selectOpen,
  setSelectOpen,
  importStep,
  setActive,
  contactsFilters,
  setContactsFilters,
  response,
  setResponse,
  originID,
  setoriginID,
  continueLoader,
  setContinueLoader,
  resetForm,
  showMappingScreen,
  setShowMappingScreen
}) => {
  const [mappingFields, setMappingFields] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [attributeScopes, setAttributeScopes] = useState([]);
  const [isLoadingAttributes, setIsLoadingAttributes] = useState(false);
  const [addAttributeModal, setAddAttributeModal] = useState(false);
  const [selectedScope, setSelectedScope] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const [newAttribute, setNewAttribute] = useState({
    name: '',
    type: '',
    scopeId: null,
    scopeLabel: ''
  });
  const [attributeTypes, setAttributeTypes] = useState([]);
  const [isLoadingTypes, setIsLoadingTypes] = useState(false);
  const [audienceSets, setAudienceSets] = useState([]);
  const [selectedAudienceSet, setSelectedAudienceSet] = useState(null);
  const [isAudienceDropdownOpen, setIsAudienceDropdownOpen] = useState(false);
  const [isLoadingAudienceSets, setIsLoadingAudienceSets] = useState(false);

  const [fileLoader, setFileLoader] = useState(false);

  const { currentBrand, toggleToast, featureFlags } = useAspSelector((state) => state.app);
  const dispatch = useDispatch();

  const downloadUrl = `${gainwix_icons}/assets/gainwix-images/sample_file_crm.xlsx`;
  const isAudienceSetFeatureEnabled = featureFlags?.ams_feature;

  useEffect(() => {
    if (currentBrand?.brand_id) {
      fetchAttributeList();
      fetchAttributeTypes();
      fetchAudienceSets();
    }
  }, [currentBrand?.brand_id]);

  const fetchAttributeTypes = async () => {
    try {
      setIsLoadingTypes(true);
      const response = await AttributeTypes(currentBrand?.brand_id);
      if (response?.status === 200 && response?.data?.attribute_types) {
        setAttributeTypes(response.data.attribute_types);
      }
    } catch (error) {
      console.error("Error fetching attribute types:", error);
    } finally {
      setIsLoadingTypes(false);
    }
  };

  const fetchAttributeList = async () => {
    try {
      setIsLoadingAttributes(true);
      const response = await AttributeList(currentBrand?.brand_id);
      if (response?.status === 200 && response?.data?.scopes_and_attributes_list) {
        setAttributeScopes(response.data.scopes_and_attributes_list);
      }
    } catch (error) {
      console.error("Error fetching attribute list:", error);
    } finally {
      setIsLoadingAttributes(false);
    }
  };

  const fetchAudienceSets = async () => {
    try {
      setIsLoadingAudienceSets(true);
      const response = await AudienceSetList(currentBrand?.brand_id);
      if (response?.data?.data) {
        setAudienceSets(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching audience sets:", error);
    } finally {
      setIsLoadingAudienceSets(false);
    }
  };

  const selectedContactSource = contactsFilters.find((item) => item.selected);
  const Icon = selectedContactSource?.icon;

  const handleModelContactSelection = (id) => {
    setContactsFilters((prev) =>
      prev.map((item) => ({ ...item, selected: item.id === id }))
    );
    setSelectOpen(false);
    setoriginID(id);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];
    setUploadFile(selectedFile)
    const selectedFileName = selectedFile?.name?.trim();

    const isDuplicate = response?.some((file) => {
      const file_name = file?.file_name?.trim();

      const lastDotIndex = selectedFileName.lastIndexOf(".");
      const selectedFileNameWithoutExtension =
        lastDotIndex !== -1
          ? selectedFileName.substring(0, lastDotIndex)
          : selectedFileName;

      return file_name === selectedFileNameWithoutExtension;
    });

    if (!selectedFile) {
      dispatch(
        updateToggleToast([
          ...toggleToast,
          {
            id: toggleToast?.length + 1,
            content: "No file selected",
            status: "Error",
            duration: "",
          },
        ])
      );
      return;
    }

    if (response?.length < 1) {
      if (!isDuplicate) {
        handleFile(selectedFile);
      } else {
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content: "File with the same name already exists",
              status: "Error",
              duration: "",
            },
          ])
        );
      }
    } else {
      dispatch(
        updateToggleToast([
          ...toggleToast,
          {
            id: toggleToast?.length + 1,
            content: "You can only upload up to 1 file",
            status: "Error",
            duration: "",
          },
        ])
      );
    }
    e.target.value = "";
  };

  const handleFile = async (file) => {
    setContinueLoader(false);
    const filesName = file?.name?.split(".")[0];
    setFileLoader(true);

    const phoneRegex =
      /^(91 [0-9]{10}|65 [0-9]{8}|44 [0-9]{10}|971 [0-9]{9}|1 [0-9]{10}|353 [0-9]{9})$/;

    const payLoad = {
      brand_id: currentBrand?.brand_id,
      path: "bulk-upload",
    };

    try {
      const responseFile = await crmUploadFile({ file, payLoad });
      const data = await file.arrayBuffer();
      const workbook = read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const headers = utils.sheet_to_json(worksheet, { header: 1 })[0];
      let contacts = utils.sheet_to_json(worksheet, { raw: true });

      if (contacts?.length > 0) {
        // const fileColumnHeaders = Object.keys(headers);
        setFileColumns(headers);
        setContacts(contacts);

        // Create mapping fields from attribute scopes
        if (attributeScopes.length > 0) {
          const newMappingFields = [];

          attributeScopes.forEach(scope => {
            // Add null check before accessing profile_attributes
            if (scope.profile_attributes && Array.isArray(scope.profile_attributes)) {
              scope.profile_attributes.forEach(attribute => {
                // Try to find a matching column in the file
                const matchingColumn = headers.find(h => {
                  // Normalize both header and attribute name
                  const normalizedHeader = h.toLowerCase().replace(/[-\s]+/g, '_');
                  const normalizedAttributeName = attribute.name.toLowerCase().replace(/[-\s]+/g, '_');
                  return normalizedHeader === normalizedAttributeName;
                });

                newMappingFields.push({
                  scopeId: scope.id,
                  scopeName: scope.name,
                  scopeLabel: scope.label,
                  scopeDefault :scope.default,
                  attributeId: attribute.id,
                  attributeType: attribute.attribute_type,
                  attributeName: attribute.name,
                  attributeLabel: attribute.label,
                  attributeDefault: attribute.default,
                  mappingField: matchingColumn || "Ignore",
                });
              });
            }
          });

          setMappingFields(newMappingFields);
        } else {
          // Fallback to basic fields if attribute scopes aren't loaded
          const defaultCrmFields = [
            "First name",
            "Last name",
            "Email ID",
            "Mobile number",
            "Location",
            "Tags",
            "Country",
          ];

          const newMappingFields = defaultCrmFields.map((crmField) => {
            const matchingColumn = fileColumns.find((header) =>
              header.toLowerCase().includes(crmField.toLowerCase().replace(" ", ""))
            );

            return {
              crmField,
              mappingField: matchingColumn || "Ignore",
            };
          });

          setMappingFields(newMappingFields);
        }
      }

      if (contacts.length > 100000) {
        contacts = contacts.slice(0, 100000);
      }

      if (contacts.length === 0) {
        setFileLoader(false);
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast.length + 1,
              content:
                "No contacts found. Add at least one contact to send a broadcast.",
              status: "Error",
              duration: "",
            },
          ])
        );
        return;
      }

      const {
        validData,
        invalidData,
        duplicateData,
        validContacts,
        duplicateContacts,
        invalidContacts,
      } = processContacts(contacts, phoneRegex);

      if (!validContacts[0]["mobile-number"]) {
        setFileLoader(false);
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast.length + 1,
              content: "Can't Read File. Use Google Sheets / Office Download.",
              status: "Error",
              duration: "",
            },
          ])
        );
        return;
      }

      if (responseFile) {
        const newFileData = {
          file_name: filesName,
          file_url: responseFile,
          valid_count: validContacts.length,
          duplicate_count: duplicateContacts.length,
          invalid_count: invalidContacts.length,
          file_data_valid: validData,
          file_data_invalid: invalidData,
          file_data_duplicate: duplicateData,
        };
        setResponse((prev) => [...prev, newFileData]);
        return [newFileData];
      };
    } catch (error) {
      console.error("Error uploading file:", error);
      setFileLoader(false);
    } finally {
      setFileLoader(false);
    }
  };

  const processContacts = (contacts, phoneRegex) => {
    const uniquePhoneNumbers = new Set();
    const uniqueEmails = new Set();
    const validContacts = [];
    const duplicateContacts = [];
    const invalidContacts = [];

    contacts.forEach((contact) => {
      const phoneNumber = contact["mobile-number"]
        ? String(contact["mobile-number"])?.replace(/\s+/g, '')
        : null;
      const email = contact["email-id"]
        ? String(contact["email-id"]).trim().toLowerCase()
        : null;

      const countryCode = contact["country-code"]
      ? String(contact["country-code"])?.replace(/\s+/g, '')
        : "";

      if (!phoneNumber || !countryCode) {
        invalidContacts.push({
          ...contact,
          reason: !countryCode
            ? "Missing country code"
            : "Missing phone number",
        });
        return;
      }

      const fullPhoneNumber = `${countryCode} ${phoneNumber}`;
      const isValidPhone = phoneRegex.test(fullPhoneNumber);
      const isDuplicatePhone = uniquePhoneNumbers.has(fullPhoneNumber);
      const isDuplicateEmail = email && uniqueEmails.has(email);

      if (!isValidPhone) {
        invalidContacts.push({
          ...contact,
          reason: "Invalid phone number"
        });
      } else if (isDuplicatePhone) {
        duplicateContacts.push({
          ...contact,
          reason: "Duplicate mobile number"
        });
      } else if (email && isDuplicateEmail) {
        duplicateContacts.push({
          ...contact,
          reason: "Duplicate email ID"
        });
      } else {
        // Only add to valid contacts if phone is valid and not duplicate, and email (if exists) is not duplicate
        uniquePhoneNumbers.add(fullPhoneNumber);
        if (email) uniqueEmails.add(email);
        validContacts.push(contact);
      }
    });

    const mapContactData = (contactList, mappingFields) => {
      return contactList.map((contact) => {
        const getFieldValue = (field) => {
          let value = contact[field];

          if (value !== undefined && value !== null && value !== "") {
            value = String(value)?.replace(/\s+/g, '');

            if (field === "first-name" || field === "last-name") {
              value = value.replace(/[^a-zA-Z\s]/g, "");
            }

            return value || null;
          }

          return null;
        };

        // Create details object with all mapped fields and profile_attributes
        const details = {
          profile_attributes: {}
        };

        // Add default fields
        const defaultFields = [
          { field: "email-id", mapping: "email-id" },
          { field: "last-name", mapping: "last-name" },
          { field: "first-name", mapping: "first-name" },
          { field: "mobile-number", mapping: "mobile-number" },
          { field: "country-code", mapping: "country-code" },
          { field: "country", mapping: "country" },
          { field: "province", mapping: "province" },
          { field: "city", mapping: "city" },
          { field: "whatsapp-otp-out", mapping: "whatsapp-otp-in" }
        ];

        
        // Add default fields if they exist in mappingFields
        defaultFields?.forEach(({ field, mapping }) => {
          const mappedField = mappingFields?.find(m => {
            return m.mappingField === mapping
          });
          if (mappedField?.mappingField && mappedField.mappingField !== 'Ignore') {
            details[field] = getFieldValue(mappedField.mappingField);
          }
        });

        // Add custom mapped fields
        mappingFields?.forEach(field => {
          if (field?.attributeName && field?.mappingField && field?.mappingField !== 'Ignore') {
            // Use attribute name as the key and get value from mapped field
            details['profile_attributes'][field?.attributeName] = getFieldValue(field?.mappingField);
          }
        });

        return {
          row: contact.__rowNum__ || null,
          mobile1: getFieldValue("country-code")
            ? getFieldValue("country-code") +
              " " +
              getFieldValue("mobile-number")?.replace(/\s+/g, "")
            : getFieldValue("mobile-number")?.replace(/\s+/g, "") || null,
          details: details,
          error: contact.error || "",
        };
      });
    }

    if (validContacts.length === 0 && validContacts[0]["mobile-number"]) {
      setFileLoader(false);
      dispatch(
        updateToggleToast([
          ...toggleToast,
          {
            id: toggleToast.length + 1,
            content:
              "No contacts found. Add at least one contact to send a broadcast.",
            status: "Error",
            duration: "",
          },
        ])
      );
      return;
    }

    return {
      validData: validContacts.length > 0 ? mapContactData(validContacts, mappingFields) : [],
      invalidData:
        invalidContacts.length > 0 ? mapContactData(invalidContacts) : [],
      duplicateData:
        duplicateContacts.length > 0 ? mapContactData(duplicateContacts) : [],
      validContacts,
      duplicateContacts,
      invalidContacts,
    };
  };

  const handleDeleteCrm = (id) => {
    const res = response?.filter((item) => item?.id !== id);
    setResponse(res);
  };

  const handleContinue = () => {
    // Now this function only shows the mapping screen
    if (fileColumns.length > 0) {
      setShowMappingScreen(true);
    } else {
      dispatch(
        updateToggleToast([
          ...toggleToast,
          {
            id: toggleToast.length + 1,
            content: "No columns found in the uploaded file.",
            status: "Error",
            duration: "",
          },
        ])
      );
    }
  };

  const handleImport = async () => {
    setContinueLoader(true);
    try {
      const fileData = await handleFile(uploadFile);
      const payLoad = {
        brand_id: currentBrand?.brand_id,
        contact_origin_id: originID,
        audience_set_id: selectedAudienceSet?.id || null,
        file_datas: fileData,
      };
      const res = await crmBulkUpload(payLoad);
      if (res?.status === 200) {
        setActive(false);
        setContinueLoader(false);
        resetForm();
      } else {
        setContinueLoader(false);
        resetForm();
        setActive(false);
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast.length + 1,
              content: res?.response?.data?.error,
              status: "Error",
              duration: "",
            },
          ])
        );
      }
    } catch (error) {
      setContinueLoader(false);
      dispatch(
        updateToggleToast([
          ...toggleToast,
          {
            id: toggleToast.length + 1,
            content: "Error processing file upload",
            status: "Error",
            duration: "",
          },
        ])
      );
    }
  };

  if (showMappingScreen) {
    return (
      <ColumnMapping
        mappingFields={mappingFields}
        setMappingFields={setMappingFields}
        fileColumns={fileColumns}
        attributeScopes={attributeScopes}
        setAttributeScopes={setAttributeScopes}
        onBack={() => {
          setShowMappingScreen(false);
          setActive(1);
        }}
        onImport={handleImport}
        continueLoader={continueLoader}
        isLoadingAttributes={isLoadingAttributes}
        onAddAttribute={fetchAttributeList}
        brandId={currentBrand?.brand_id}
        contacts={contacts}
      />
    );
  }


  return (
    <div className="w-full h-full relative">
      <div className="h-[calc(100%-60px)] overflow-y-auto p-[1vw]">
        {/* Select contact origin */}
        <>
          <p className="font14px-400 text-[var(--textBlack)]">
            Select a contact origin
            <sup className="text-red-500">*</sup>
          </p>
          <Dropdown
            open={selectOpen}
            setOpen={setSelectOpen}
            data={contactsFilters}
            width="min-w-[43vw]"
            height="max-h-[32vh]"
            containerClassNames="px-[1.6vw]"
            editFilter={handleModelContactSelection}
            button={
              <div className="">
                <div
                  className={`flex justify-between items-center my-[2vh]- py-[1vh] ps-[.5vw] pe-[.7vw] cursor-pointer transition-colors duration-100 text-[0.85vw] border border-gray-200 rounded-lg`}
                  onClick={() => setSelectOpen(!selectOpen)}
                >
                  <p
                    className={`flex items-center gap-[.4vw] ${
                      selectedContactSource?.label
                        ? "text-[var(--textBlack)] font15px-500"
                        : "text-[var(--font-400)] font14px-400"
                    }`}
                  >
                    {Icon && <Icon width="1.3vw" />}
                    {selectedContactSource?.label || "Select Origin"}
                  </p>
                  <span
                    className={`duration-300 ${
                      selectOpen ? "-rotate-180" : "rotate-0"
                    }`}
                  >
                    <div className="border-[0.4vw] rounded-t-[0.2vw] border-transparent border-t-[#777] translate-y-[25%]" />
                  </span>
                </div>
              </div>
            }
          />
        </>

        {/* Audience Set Dropdown - Only show if feature is enabled */}
        {isAudienceSetFeatureEnabled && (
          <>
            <p className="font14px-400 text-[var(--textBlack)] mt-6">
              Select an audience set
            </p>
            <Dropdown
              open={isAudienceDropdownOpen}
              setOpen={setIsAudienceDropdownOpen}
              data={[
                { id: "", name: "None", label: "None", selected: !selectedAudienceSet },
                ...audienceSets.map(set => ({
                  id: set.id,
                  name: set.name,
                  label: set.name,
                  selected: selectedAudienceSet?.id === set.id
                }))
              ]}
              width="min-w-[43vw]"
              height="max-h-[32vh]"
              containerClassNames="px-[1.6vw]"
              editFilter={(id) => {
                const selected = audienceSets.find(set => set.id === id) || null;
                setSelectedAudienceSet(selected);
              }}
              button={
                <div className="">
                  <div
                    className="flex justify-between items-center my-[2vh]- py-[1vh] ps-[.5vw] pe-[.7vw] cursor-pointer transition-colors duration-100 text-[0.85vw] border border-gray-200 rounded-lg"
                    onClick={() => setIsAudienceDropdownOpen(!isAudienceDropdownOpen)}
                  >
                    <p
                      className={`flex items-center gap-[.4vw] ${
                        selectedAudienceSet?.name
                          ? "text-[var(--textBlack)] font15px-500"
                          : "text-[var(--font-400)] font14px-400"
                      }`}
                    >
                      {selectedAudienceSet?.name || "Select Audience Set"}
                    </p>
                    <span
                      className={`duration-300 ${
                        isAudienceDropdownOpen ? "-rotate-180" : "rotate-0"
                      }`}
                    >
                      <div className="border-[0.4vw] rounded-t-[0.2vw] border-transparent border-t-[#777] translate-y-[25%]" />
                    </span>
                  </div>
                </div>
              }
            />
          </>
        )}

        {/* Upload file */}
        <div className="Audience_download flex-row align-center w-100 space-between align-center pt-15">
          <span className="font14px-400 text-[var(--textBlack)] pb-5">
            Upload a single file
          </span>
          <a href={downloadUrl}>
            <div className="flex-row align-center pointer pb-10">
              <img
                src={ICONS?.AudienceDownloadIcon}
                alt=""
                // style={{ width: "16px", height: "16px" }}
              />
              <span className="font15px-500 text-[var(--textBlack)]">
                Download Sample
              </span>
            </div>
          </a>
        </div>

        <div
          className="upload-container "
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <label className="uploadLabel flex-column justify-center align-center">
            <input
              className="input"
              type="file"
              onChange={handleChange}
              accept=".xlsx"
            />
            <div className="duplicateButton flex-row align-center justify-center">
              {fileLoader ? (
                <div
                  className="loaderWrapper flex-row align-center justify-center pt-10 "
                  style={{ width: "60px" }}
                >
                  <Loader Width={20} Height={20} loaderBg="white" />
                </div>
              ) : (
                "Choose file"
              )}
            </div>
            <div className="flex-column">
              <p>( Drag & Drop the file to upload )</p>
              <p>.xlsx</p>
            </div>
          </label>
        </div>
        <FileDownload
          key={response?.id}
          file_name={response?.file_name}
          response={response}
          setResponse={setResponse}
          handleDeleteCrm={handleDeleteCrm}
        />
      </div>
      <div className="sticky bottom-0 rounded-br-2xl">
        <hr />
        <div className="px-[1vw] py-[.5vw] flex-row justify-end align-end">
          {response?.length === 1 && originID ? (
            <button
              className="button-primary px-4 py-1.5"
              onClick={handleContinue}
            >
              {continueLoader ? (
                <Loader Width={70} Height={18} loaderBg="white" />
              ) : (
                "Continue"
              )}
            </button>
          ) : (
            <span className="button-primary px-4 py-1.5 opacity-50">Continue</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadFromCsv;
